// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2tQ40","header":"PatientQuestionnaire_header__2iZeZ","info":"PatientQuestionnaire_info__34Hwa"};